// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__2Y","cls2":"CreateSocialItemModal-cls2_Fe8 CreateSocialItemModal-cls1__2Y"};